import React, { FC } from 'react';
import { Typography } from '../../../../../components/Typography';
import { PaddingBox } from '../../../../../components/PaddingBox';
import classes from './style/underlinedSection.module.scss';

export type PublicJobDetailUnderlinedSectionProps = {
	title: string;
};

export const PublicJobDetailUnderlinedSection: FC<React.PropsWithChildren<PublicJobDetailUnderlinedSectionProps>> = ({
	title,
	children,
}) => {
	return (
		<div className={classes.underlinedSection}>
			<PaddingBox bottomSmall>
				<Typography bold>{title}</Typography>
			</PaddingBox>
			{children}
		</div>
	);
};
